import { ArrowLeft, Trash2, Workflow } from "lucide-react";
import WhatsAppPreview from "./WhatsAppPreview";
import { StatusPill } from "./status";
import { focusRing } from "./ui";
import TemplateFieldsCard from "./TemplateFieldsCard";

// One template on its own page: just the message, as customers see it. The reason Meta gave
// is shown only when it turned the template down, because that is what the next step needs.
export default function TemplateDetail({ row, brandName, tenantId, onBack, onDelete, onAssign }) {
  const canAssign = row.status !== "rejected" && row.status !== "failed" && ["text", "image", "video", "document"].includes(row.template_type || "text");
  return (
    <div>
      <div className="mb-8 flex flex-wrap items-center gap-4">
        <button
          type="button"
          onClick={onBack}
          className={`inline-flex h-10 cursor-pointer items-center gap-2 rounded-full bg-[#F3F4F6] pl-3 pr-4 text-[14px] font-medium text-[#374151] transition-colors duration-150 hover:bg-[#E5E7EB] ${focusRing}`}
        >
          <ArrowLeft size={16} aria-hidden="true" /> All templates
        </button>
        <h2 className="m-0 min-w-0 truncate text-[20px] font-semibold text-[#111827]">{row.name}</h2>
        <StatusPill status={row.status} />
        {canAssign && (
          <button
            type="button"
            onClick={() => onAssign(row)}
            className={`ml-auto inline-flex h-10 cursor-pointer items-center gap-2 rounded-full bg-[#EFF5FC] px-4 text-[14px] font-medium text-[#1F5596] transition-colors duration-150 hover:bg-[#DCE9F8] ${focusRing}`}
          >
            <Workflow size={16} aria-hidden="true" /> Use for a step
          </button>
        )}
        <button
          type="button"
          onClick={() => onDelete(row)}
          className={`${canAssign ? "" : "ml-auto "}inline-flex h-10 cursor-pointer items-center gap-2 rounded-full bg-[#FEF2F2] px-4 text-[14px] font-medium text-[#B91C1C] transition-colors duration-150 hover:bg-[#FEE2E2] ${focusRing}`}
        >
          <Trash2 size={16} aria-hidden="true" /> Delete
        </button>
      </div>

      <div className="mx-auto flex max-w-[400px] flex-col gap-5">
        <WhatsAppPreview
          brandName={brandName}
          header={row.header_text}
          body={row.body}
          examples={row.body_examples}
          footer={row.footer_text}
          buttons={row.buttons}
          type={row.template_type || "text"}
          mediaUrl={row.media_url || ""}
          cards={row.cards || []}
          otp={row.otp || null}
        />
        <TemplateFieldsCard key={row.id} row={row} tenantId={tenantId} />
        {row.reason && (
          <div role="note" className="rounded-xl bg-[#FEF2F2] px-4 py-3 text-[14px] leading-5 text-[#991B1B]">
            <div className="mb-[2px] font-semibold">{row.status === "rejected" ? "Why Meta said no" : "What went wrong"}</div>
            {row.reason}
          </div>
        )}
      </div>
    </div>
  );
}
